import { default as card_45basicB8CpzHnMarMeta } from "/app/pages/card-basic.vue?macro=true";
import { default as cardsPWuoOV9bp7Meta } from "/app/pages/cards.vue?macro=true";
import { default as configsblWupGdNNTMeta } from "/app/pages/configs.vue?macro=true";
import { default as dashboardJu37u7k0toMeta } from "/app/pages/dashboard.vue?macro=true";
import { default as form_45layoutsVWRE9IQWVTMeta } from "/app/pages/form-layouts.vue?macro=true";
import { default as iconsAVqGQpFjv7Meta } from "/app/pages/icons.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as logoutHaVXWqg8UAMeta } from "/app/pages/logout.vue?macro=true";
import { default as index5xvWIebeBFMeta } from "/app/pages/manage-tokens/index.vue?macro=true";
import { default as playgroundE6K1PGYpTcMeta } from "/app/pages/playground.vue?macro=true";
import { default as profileupBlgdy3vLMeta } from "/app/pages/profile.vue?macro=true";
import { default as registermu8R7rSP5uMeta } from "/app/pages/register.vue?macro=true";
import { default as signalsab6TrqlVGHMeta } from "/app/pages/signals.vue?macro=true";
import { default as system_45settingsnNVPajra5JMeta } from "/app/pages/system-settings.vue?macro=true";
import { default as tablesObwGmyK6sPMeta } from "/app/pages/tables.vue?macro=true";
import { default as typography9CNEixg9THMeta } from "/app/pages/typography.vue?macro=true";
export default [
  {
    name: "card-basic",
    path: "/card-basic",
    component: () => import("/app/pages/card-basic.vue")
  },
  {
    name: "cards",
    path: "/cards",
    component: () => import("/app/pages/cards.vue")
  },
  {
    name: "configs",
    path: "/configs",
    meta: configsblWupGdNNTMeta || {},
    component: () => import("/app/pages/configs.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardJu37u7k0toMeta || {},
    component: () => import("/app/pages/dashboard.vue")
  },
  {
    name: "form-layouts",
    path: "/form-layouts",
    component: () => import("/app/pages/form-layouts.vue")
  },
  {
    name: "icons",
    path: "/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logoutHaVXWqg8UAMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "manage-tokens",
    path: "/manage-tokens",
    meta: index5xvWIebeBFMeta || {},
    component: () => import("/app/pages/manage-tokens/index.vue")
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundE6K1PGYpTcMeta || {},
    component: () => import("/app/pages/playground.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profileupBlgdy3vLMeta || {},
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registermu8R7rSP5uMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "signals",
    path: "/signals",
    meta: signalsab6TrqlVGHMeta || {},
    component: () => import("/app/pages/signals.vue")
  },
  {
    name: "system-settings",
    path: "/system-settings",
    meta: system_45settingsnNVPajra5JMeta || {},
    component: () => import("/app/pages/system-settings.vue")
  },
  {
    name: "tables",
    path: "/tables",
    component: () => import("/app/pages/tables.vue")
  },
  {
    name: "typography",
    path: "/typography",
    component: () => import("/app/pages/typography.vue")
  }
]